export default __webpack_public_path__ + "static/SR France - HACCP - Statement-8cbf9027dabe44564737d7a95430ceec.pdf";